import {Control, useWatch} from "react-hook-form";
import React, {useMemo} from "react";
import {getAutocompletePremiumAgents} from "../../common/util/helpers";
import {useTranslation} from "react-i18next";
import {useTableWithAdjustableOrder} from "../../common/components/table/useTableWithAdjustableOrder";
import {BasicUser, Site} from "../../app/types";
import {formatUserInDropdown} from "../../common/util/formatters";
import FormRow from "../../common/form/FormRow";
import FormFieldBox from "../../common/form/FormFieldBox";
import {Box, Paper} from "@mui/material";
import FormGroup from "../../common/form/FormGroup";

type Props= {
    control: Control<any>
    site : Site | null
}

export default function SkilledAgentsSelection ({control, site} : Props){
    const { t } = useTranslation()

    const skill1Agents : BasicUser[] = useWatch({
        control,
        name: 'skilledAgent1Users',
    })

    const skill6Agents: BasicUser[] = useWatch({
        control,
        name: 'skilledAgent6Users',
    })

    const skill11Agents: BasicUser[] = useWatch({
        control,
        name: 'skilledAgent11Users',
    })

    const agent1OptionParams = useMemo(() =>
            getAutocompletePremiumAgents(
                t('flows.edit.no-users-found'),
                [...(skill6Agents.map((ag: BasicUser)  => ag.uuid)), ...(skill11Agents.map((ag: BasicUser)  => ag.uuid))],
                site)
        , [site, t, skill6Agents, skill11Agents])

    const agent6OptionParams = useMemo(() =>
            getAutocompletePremiumAgents(
                t('flows.edit.no-users-found'),
                [...(skill1Agents.map((ag: BasicUser)  => ag.uuid)), ...(skill11Agents.map((ag: BasicUser)  => ag.uuid))],
                site)
        , [site, t, skill1Agents, skill11Agents])

    const agent11OptionParams = useMemo(() =>
            getAutocompletePremiumAgents(
                t('flows.edit.no-users-found'),
                [...(skill1Agents.map((ag: BasicUser)  => ag.uuid)), ...(skill6Agents.map((ag: BasicUser)  => ag.uuid))],
                site)
        , [site, t, skill1Agents, skill6Agents])

    const { table: Skilled1AgentTable, selector: Skilled1Selector } = useTableWithAdjustableOrder<BasicUser>('skilledAgent1Users', agent1OptionParams, control, formatUserInDropdown, user => user.uuid, t('users.edit.user-select-button'), false)
    const { table: Skilled6AgentTable, selector: Skilled6Selector } = useTableWithAdjustableOrder<BasicUser>('skilledAgent6Users', agent6OptionParams, control, formatUserInDropdown, user => user.uuid, t('users.edit.user-select-button'), false)
    const { table: Skilled11AgentTable, selector: Skilled11Selector } = useTableWithAdjustableOrder<BasicUser>('skilledAgent11Users', agent11OptionParams, control, formatUserInDropdown, user => user.uuid, t('users.edit.user-select-button'), false)

    return <>
        <Box sx={{mb: {xs: 2, md: 3}}}>
            <FormGroup label={t('flows.edit.section.agents-skill1')} fullWidth={true}>
                <FormRow>
                    <FormFieldBox mdSize={8} lgSize={6}>
                        {Skilled1Selector}
                    </FormFieldBox>
                </FormRow>
                <FormRow>
                    <FormFieldBox mdSize={12}>
                        <Paper elevation={2}>
                            <Skilled1AgentTable />
                        </Paper>
                    </FormFieldBox>
                </FormRow>
            </FormGroup>
        </Box>
        <Box sx={{mb: {xs: 2, md: 3}}}>
            <FormGroup label={t('flows.edit.section.agents-skill6')} fullWidth={true}>
                <FormRow>
                    <FormFieldBox mdSize={8} lgSize={6}>
                        {Skilled6Selector}
                    </FormFieldBox>
                </FormRow>
                <FormRow>
                    <FormFieldBox mdSize={12}>
                        <Paper elevation={2}>
                            <Skilled6AgentTable />
                        </Paper>
                    </FormFieldBox>
                </FormRow>
            </FormGroup>
        </Box>
        <Box>
            <FormGroup label={t('flows.edit.section.agents-skill11')} fullWidth={true}>
                <FormRow>
                    <FormFieldBox mdSize={8} lgSize={6}>
                        {Skilled11Selector}
                    </FormFieldBox>
                </FormRow>
                <FormRow>
                    <FormFieldBox mdSize={12}>
                        <Paper elevation={2}>
                            <Skilled11AgentTable />
                        </Paper>
                    </FormFieldBox>
                </FormRow>
            </FormGroup>
        </Box>
    </>

}